import React from 'react'
import PropTypes from 'prop-types'
import { Image, StyleSheet } from 'react-native'

const s3URL = 'https://d2in4d3ntxbclu.cloudfront.net/images/320px/'

type ProductDisplayImageProps = {
  /** Show the small image when scrolled far enough on mobile. */
  shrinkImage: boolean,
  /** The default SKU to display for the product family. */
  defaultSKU: string,
  partner: string,
}

export const ProductDisplayImage = ({shrinkImage, defaultSKU, partner}: ProductDisplayImageProps) => {
  return (
    <Image
      resizeMode={'contain'}
      style={shrinkImage ? styles.imageSmall : styles.image}
      source={{uri: s3URL + ((partner == 'fisher' || partner == 'fisheredu') ? 'fisher/' : 'standard/') + defaultSKU + '.png'}}
    ></Image>
  )
}

ProductDisplayImage.propTypes = {
  shrinkImage: PropTypes.bool.isRequired,
  defaultSKU: PropTypes.string.isRequired,
}

ProductDisplayImage.defaultProps = {
  shrinkImage: false,
  defaultSKU: 'VDHCH-RG-T0-A0-RC-8540',
}

const styles = StyleSheet.create({
  image: {
    width: '100%',
    margin: 0,
    height: 400,
  },
  imageSmall: {
    width: '100%',
    margin: 0,
    height: 200,
  },
})
